module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Compass.js"));
	}, "Compass");
}